import type { StylesConfig } from 'react-select'

import { ADVANCED_ACCOUNTING_CLASS_NAME, STYLED_THEME } from '@constants'

function getSelectBorderColor(state: { isDisabled: boolean; isFocused: boolean }) {
  if (state.isFocused) {
    return STYLED_THEME.colors.common.outlineBlue
  }
  return state.isDisabled ? STYLED_THEME.colors.field.disabledBorder : STYLED_THEME.colors.field.border
}

export const selectFormStyles: StylesConfig<any, false> = {
  container: provided => ({
    ...provided,
    '&.error>div': {
      borderColor: `${STYLED_THEME.colors.error[150]} !important`,
    },
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: 36,
    // height: 36,
    backgroundColor: state.isDisabled
      ? STYLED_THEME.colors.field.disabledBackground
      : STYLED_THEME.colors.field.background,
    borderColor: getSelectBorderColor(state),
    boxShadow: 'none',

    '&:hover': {
      borderColor: getSelectBorderColor(state),
    },

    '.highlighted > &': {
      borderColor: state.isFocused ? STYLED_THEME.colors.common.outlineBlue : STYLED_THEME.colors.primary[50],
    },

    [`.${ADVANCED_ACCOUNTING_CLASS_NAME} .highlighted > &`]: {
      borderColor: state.isFocused ? STYLED_THEME.colors.common.outlineBlue : STYLED_THEME.colors.common.purple,
    },
  }),
  menu: provided => ({
    ...provided,
    zIndex: 10,
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? STYLED_THEME.colors.field.disabledValue : STYLED_THEME.colors.field.value,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? STYLED_THEME.colors.field.disabledValue : STYLED_THEME.colors.field.value,
  }),
  input: provided => ({
    ...provided,
    visibility: 'visible',
    color: 'inherit',
    margin: 0,
    paddingBottom: 0,
    paddingTop: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  clearIndicator: provided => ({
    ...provided,
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
    },
    '&>svg': {
      width: 16,
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: '0 4px',
    color: state.isDisabled ? STYLED_THEME.colors.field.disabledPlaceholder : STYLED_THEME.colors.field.value,
    '&:hover': {
      cursor: 'pointer',
      color: STYLED_THEME.colors.field.value,
    },
    '&>svg': {
      width: 18,
      height: 18,
    },
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? STYLED_THEME.colors.field.disabledPlaceholder : STYLED_THEME.colors.field.placeholder,
  }),
  multiValue: provided => ({
    ...provided,
    backgroundColor: STYLED_THEME.colors.secondary[10],
  }),
  multiValueLabel: provided => ({
    ...provided,
    color: STYLED_THEME.colors.blue[40],
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    backgroundColor: 'transparent',
    color: state.isFocused ? STYLED_THEME.colors.gray[100] : STYLED_THEME.colors.blue[40],
    '&:hover': {
      backgroundColor: 'transparent',
      color: STYLED_THEME.colors.gray[100],
      cursor: 'pointer',
    },
  }),
  groupHeading: provided => ({
    ...provided,
    fontWeight: 600,
    textTransform: 'none',
    color: STYLED_THEME.colors.primary[50],
  }),
  group: provided => ({
    ...provided,
    paddingBottom: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? state.isFocused
        ? 'rgba(0, 126, 255, 0.2)'
        : 'rgba(0, 126, 255, 0.14)'
      : state.isFocused
        ? 'rgba(0, 126, 255, 0.04)'
        : 'transparent',
    color: STYLED_THEME.colors.common.midnightEscape,
    padding: '4px 12px',

    '&:active': {
      backgroundColor: 'rgba(0, 126, 255, 0.2)',
    },
    '.custom-option': {
      display: 'block',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    '& span.badge': {
      fontSize: '75%',
      color: STYLED_THEME.colors.common.inputLabel,
    },
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  noOptionsMessage: provided => ({
    ...provided,
    fontSize: 12,
    textAlign: 'left',
  }),
  loadingMessage: provided => ({
    ...provided,
    fontSize: 12,
    textAlign: 'left',
  }),
}
